$(document).ready(function() {
    $('.js-form-search').on('submit', function(e) {
        const searchInput = $('.js-site-search__textbox', $(this));
        const screenWidth = $(window).width();

        if (!searchInput.is(':visible')) {
            e.preventDefault();

            let width;
            if (screenWidth > 920) {
                width = 456;
            } else if (screenWidth > 870) {
                width = 396;
            } else if (screenWidth > 820) {
                width = 440;
            } else {
                width = 360;
            }

            if ($('.ab553').length) {
                const $container = $('.ab553');
                $container.addClass('is-open--tablet');
            }

            searchInput.addClass('header__input-search__active').animate({ width: width }, 600, function() {
                $('.site-search__typeahead').css({ float: 'left' });
                if (screenWidth <= 820) {
                    searchInput.css('padding-top', '5px');
                }
                searchInput.focus();
            });
        } else if(searchInput.is(':visible') && searchInput.val() === '' && screenWidth < 1001) {
          // if input field is visible and empty close input field when clicking search icon
          e.preventDefault();
          closeSearchInput(searchInput);
        }
    });

    function closeSearchInput(searchInputActive) {
        if ($('.ab553').length) {
            const $container = $('.ab553');
            $container.removeClass('is-open--tablet');
        }
        searchInputActive.animate({width: 0}, 600, function() {
            searchInputActive.removeClass('header__input-search__active');
            $('.site-search__typeahead').css({float: ''});
        });
    }

    $(document).on('click', function(e) {
        const searchInputActive = $('.header__input-search__active');
        if(searchInputActive && !$(e.target).is('.header__input-search__active, .site-search__typeahead')) {
            closeSearchInput(searchInputActive)
        }
    })
    $(document).on('keyup', function(e) {
        if(e.key == "Enter" && $('.header__input-search__active').length) {
            if ($('.ab553').length && !$(e.target).hasClass('js-visual-search-button')) {
                $('.header__input-search__active').focus();
            }
        }
        if(e.key == "Escape" &&
            ($('.header__input-search__active').is(":focus") || $('.header__icon-search').is(":focus")) &&
            $('.header__input-search__active').length) {
            closeSearchInput($('.header__input-search__active'));
            $('.header__icon-search').focus();
        }
    })
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/header.js